// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Banques
export default class Bank  {
  // Identifiant unique
  public id: number;
  // Nom de la banque
  public banque: string;
  // Code CIB
  public cib: string;
  // Code BIC
  public bic: string;
  // Pays
  public paysId: number;
  // Pays
  public pays: string;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.banque = '';
    this.cib = '';
    this.bic = '';
    this.paysId = 0;
    this.pays = '';
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Bank): Bank {
    const newBank: Bank = new Bank();
    newBank.id = obj.id;
    newBank.banque = obj.banque;
    newBank.cib = obj.cib;
    newBank.bic = obj.bic;
    newBank.paysId = obj.paysId;
    newBank.pays = obj.pays;
    newBank.createId = obj.createId;
    newBank.failed = obj.failed;
    newBank.canUpdate = obj.canUpdate;
    newBank.canDelete = obj.canDelete;
    newBank.display = obj.display;
    newBank.notifDefType = obj.notifDefType;
    return newBank;
  }

  public toJsonBank (): string {
    const json = {
      banque: this.banque,
      cib: this.cib,
      bic: this.bic,
      paysId: this.paysId,
      pays: this.pays,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromBank (obj: Bank): void {
    this.id = obj.id;
    this.banque = obj.banque;
    this.cib = obj.cib;
    this.bic = obj.bic;
    this.paysId = obj.paysId;
    this.pays = obj.pays;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareBank (value: Bank): boolean {
    return (this.toJsonBank() == value.toJsonBank());
  }

  public cloneBank (): Bank {
    return Bank.fromJson(this);
  }

  public createForStoreBank (): Promise<Bank> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/banks/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromBank(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreBank (): Promise<Bank> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/banks/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromBank(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreBank (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/banks/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/banks/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Banks/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Bank.fromJson(listData.reccords[0] as Bank);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Bank> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Banks/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Bank.fromJson(listData.reccords[0] as Bank);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(banks: Bank[]) {
  }
}
